export class SaasMailDetails {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "subject",
            "baseName": "subject",
            "type": "string",
            "format": ""
        },
        {
            "name": "_from",
            "baseName": "from",
            "type": "string",
            "format": ""
        },
        {
            "name": "to",
            "baseName": "to",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasMailDetails.attributeTypeMap;
    }
    constructor() {
    }
}
